export const getters = {
  organization: ({ organization }) => organization,
};
